import type { IncidentReviewOutcomeRollupResponse } from '../../services/incidentsApi';
import type { CustomerMetric } from '../customerMetrics';
import { customerMetricsSharePopulation, findCustomerMetric } from '../customerMetrics';

export type CanonicalReviewPopulation = {
  total: number;
  reviewed: number;
  pending: number;
  totalMetric: CustomerMetric | null;
  reviewedMetric: CustomerMetric | null;
  pendingMetric: CustomerMetric | null;
  ratioAllowed: boolean;
};

function normalizeCount(value: unknown): number {
  const n = Number(value);
  return Number.isFinite(n) ? Math.max(0, Math.trunc(n)) : 0;
}

export function resolveCanonicalReviewPopulation(
  rollup?: Pick<IncidentReviewOutcomeRollupResponse, 'total_incidents' | 'reviewed_total' | 'semantic_metrics'> | null,
): CanonicalReviewPopulation {
  const totalMetric = findCustomerMetric(rollup?.semantic_metrics || [], 'review.total_reviewable_observation_count');
  const reviewedMetric = findCustomerMetric(rollup?.semantic_metrics || [], 'review.reviewed_observation_count');
  const pendingMetric = findCustomerMetric(rollup?.semantic_metrics || [], 'review.pending_observation_count');
  const ratioAllowed = customerMetricsSharePopulation(totalMetric, reviewedMetric);
  const total = totalMetric ? normalizeCount(totalMetric.value) : normalizeCount(rollup?.total_incidents);
  const reviewed = reviewedMetric ? normalizeCount(reviewedMetric.value) : normalizeCount(rollup?.reviewed_total);
  const pending = pendingMetric
    ? normalizeCount(pendingMetric.value)
    : Math.max(0, total - reviewed);
  return {
    total,
    reviewed,
    pending,
    totalMetric,
    reviewedMetric,
    pendingMetric,
    ratioAllowed,
  };
}
